import type { ReactNode } from 'react';
import { cx } from '../../utils/cx';
import styles from './Alert.module.css';

export type AlertTone = 'neutral' | 'bad';

export interface AlertProps {
  tone?: AlertTone;
  title: string;
  children?: ReactNode;
  action?: ReactNode;
  /** Лише для технічних збоїв: де причина вже названа, код — шум. */
  code?: string;
}

function BadIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth={1.8}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 8v4M12 16h.01" strokeLinecap="round" />
    </svg>
  );
}

function NeutralIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth={1.8}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v5M12 8h.01" strokeLinecap="round" />
    </svg>
  );
}

// `alert` скрінрідер озвучує негайно, `status` — у черзі.
export function Alert({ tone = 'neutral', title, children, action, code }: AlertProps) {
  const isBad = tone === 'bad';
  const classes = cx(styles.alert, isBad && styles.bad);

  return (
    <div className={classes} role={isBad ? 'alert' : 'status'}>
      <span className={styles.icon}>{isBad ? <BadIcon /> : <NeutralIcon />}</span>
      <div className={styles.body}>
        <strong className={styles.title}>{title}</strong>
        {children ? <p className={styles.text}>{children}</p> : null}
        {code || action ? (
          <div className={styles.foot}>
            {code ? <code className={styles.code}>{code}</code> : null}
            {action}
          </div>
        ) : null}
      </div>
    </div>
  );
}
